import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Dialog } from "@mui/material";
import { useState } from "react";
import {
  Box,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
} from "@mui/material";
import MessageSectionSubmit from "./MessageSectionSubmit";

const MessageSection = ({
  type,
  admin,
  userId,
  initialNotification,
  handleNotification,
}) => {
  const [disableEdit, setDisableEdit] = useState(true);
  const [buttonLabel, setButtonLabel] = useState("Edit");
  const [submitAction, setSubmitAction] = useState("update");
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleAgree = (event) => {
    setDeleteModalOpen(false);
    setSubmitAction("delete");
    setSubmitModalOpen(true);
  };
  const handleSubmit = (val, action) => {
    setNotification(value);
    if (submitAction === "delete") {
      setValue("");
      handleNotification(val);
    }
  };
  const [notification, setNotification] = useState(initialNotification);
  const [value, setValue] = useState(notification);
  return (
    <div>
      {disableEdit ? (
        <Typography
          paragraph="true"
          sx={{
            color: "red",
            border: "1px solid black",
            minHeight: "100px",
            p: 1,
          }}
          variant="body1"
          gutterBottom
        >
          {value}
        </Typography>
      ) : (
        <TextField
          variant="standard"
          sx={{ pb: 1 }}
          fullWidth
          focused
          color="secondary"
          id="outlined-multiline-static"
          label=""
          multiline
          rows={4}
          value={value}
          onChange={handleChange}></TextField>
      )}
      {admin ? (
        <div>
          <Button
            onClick={() => {
              if (buttonLabel === "Review") {
                setButtonLabel("Post");
                setDisableEdit(true);
              } else if (buttonLabel === "Post") {
                setSubmitAction("update");
                setSubmitModalOpen(true);
                setButtonLabel("Edit");
              } else {
                setButtonLabel("Review");
                setDisableEdit(false);
              }
            }}
            sx={{ float: "right" }}
            variant="contained"
          >
            {buttonLabel}
          </Button>
          {buttonLabel === "Edit" && value.length ? (
            <Button
              color="error"
              onClick={() => {
                setDeleteModalOpen(true);
              }}
              sx={{ float: "right", mr: 1 }}
              variant="contained"
            >
              Delete
            </Button>
          ) : null}
          {buttonLabel === "Post" ? (
            <Button
              onClick={() => {
                setValue(notification);
                setButtonLabel("Edit");
              }}
              sx={{ display: "flex", float: "right", mr: 1 }}
              variant="contained"
            >
              Cancel
            </Button>
          ) : null}
        </div>
      ) : null}
      <Dialog open={submitModalOpen} onClose={() => setSubmitModalOpen(false)}>
        <MessageSectionSubmit
          action={submitAction}
          type={type}
          userId={userId}
          data={value}
          disableNotification={(val) => handleSubmit(val)}
        />
      </Dialog>
      <Dialog open={deleteModalOpen}>
        <DialogTitle id="alert-dialog-title" variant="h5">
          {"Warning"}
        </DialogTitle>
        <Divider sx={{ ml: 2, mr: 2 }} />
        <DialogContent>
          <Box>
            <>
              <Typography variant="h6" gutterBottom>
                Are you sure you want to delete the Notification ?
              </Typography>
            </>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)}>Disagree</Button>
          <Button onClick={handleAgree} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MessageSection;
